export default __webpack_public_path__ + "static/media/juego rio-15.51664b56.png";